import Navigation from './navigation/Navigation';
import { AuthProvider } from './StateManagment/Auth';
import { PermissionsProvider } from './StateManagment/Permissions';
import { ActiveMenuProvider } from './StateManagment/ActiveMenuItem';
import { SavedProvider } from './StateManagment/SavedIcon';
import { ResponsProvider } from './StateManagment/Responses';
import { ImpactAIProvider } from './StateManagment/ImpactAI';
import { ImpactAIDataProvider } from './StateManagment/ImpactAIData';
import { OnboardingProvider } from './StateManagment/Onboarding';
import { OnboardingTourProvider } from './StateManagment/OnboardingTour';
import { OnboardingFlowProvider } from './StateManagment/OnboardingFlow';
import { PersonaNavigationProvider } from './StateManagment/PersonaNavigation';
import { AdressNavigationProvider } from './StateManagment/AdressNavigation';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { DeccaProvider } from './StateManagment/DeccaContext';
import { SelectedDashBoardElementsProvider } from './StateManagment/SelectedDashboardElements';
import { SelectedDashBoardBuilderElementsProvider } from './StateManagment/SelectedDashboardBuilderElements';
import { QuestionnaireProvider } from './StateManagment/Questionnaire';
import { TranslationProvider } from './StateManagment/TranslationContext';
import { useLocation, useHistory } from "react-router-dom";
import useIsMobileUserAgent from "./hooks/useIsMobileUserAgent";
import MobileNavigation from './mobile/MobileNavigation';
import Snackbar from './components/common/Snackbar';
import ConsentGate from './components/legal/ConsentGate';
import MfaGate from './components/auth/MfaGate';
import SuperAdminBanner from './components/layout/SuperAdminBanner';

function App() {
  const location = useLocation();
  const history = useHistory();
  const isMobile = useIsMobileUserAgent();
  const s = new URLSearchParams(location.search);

  /* Set ?m=true|false based on device type */
  const hasMobileParam = s.has('m');
  
  if (isMobile !== hasMobileParam) {
    
    isMobile 
      ? s.set('m', '1') 
      : s.delete('m');

    history.replace({ 
      pathname: location.pathname, 
      search: s.toString() 
    });

    return null; /* Stop rendering, wait for redirect */
  }

  return (
    <div className="App">
        <GoogleOAuthProvider clientId="53449363588-tv6coidomou2jd4jfl42pje7i4esd8mi.apps.googleusercontent.com">
          <AuthProvider>
            <PermissionsProvider>
            <ActiveMenuProvider>
              <SavedProvider>
                <ResponsProvider>
                  <QuestionnaireProvider>
                    <DeccaProvider>
                      <ImpactAIProvider>
                        <ImpactAIDataProvider>
                          <OnboardingProvider>
                          <OnboardingTourProvider>
                            <OnboardingFlowProvider>
                              <PersonaNavigationProvider>
                                <AdressNavigationProvider>
                                  <TranslationProvider>
                                    <SelectedDashBoardElementsProvider>
                                      <SelectedDashBoardBuilderElementsProvider>
                                        <Snackbar />
                                        <ConsentGate />
                                        <MfaGate />
                                        <SuperAdminBanner />
                                        {isMobile ? <MobileNavigation /> : <Navigation />}
                                      </SelectedDashBoardBuilderElementsProvider>
                                    </SelectedDashBoardElementsProvider>
                                  </TranslationProvider>
                                </AdressNavigationProvider>
                              </PersonaNavigationProvider>
                            </OnboardingFlowProvider>
                          </OnboardingTourProvider>
                          </OnboardingProvider>
                        </ImpactAIDataProvider>
                      </ImpactAIProvider>
                    </DeccaProvider>
                  </QuestionnaireProvider>
                </ResponsProvider>
              </SavedProvider>
            </ActiveMenuProvider>
            </PermissionsProvider>
          </AuthProvider>
        </GoogleOAuthProvider>
    </div>
  );
}

export default App;
